// src/stores/useBasemapStore.js
//
// User-selectable "classic" Mapbox raster basemaps. Persisted per-device
// (see auth/persistKeys.js) so the choice survives a reload but isn't
// wiped on a different-user login — it's a display preference, not tied
// to identity or entitlements.

import { create } from "zustand";
import { persist } from "zustand/middleware";
import { getConfig } from "../config";
import { PERSIST_KEYS } from "../auth/persistKeys";

export const CLASSIC_BASEMAPS = [
  { id: "satellite-streets-v11", label: "Satellite Streets" },
  { id: "satellite-v9", label: "Satellite" },
  { id: "streets-v11", label: "Streets" },
  { id: "outdoors-v11", label: "Outdoors" },
  { id: "light-v10", label: "Light" },
  { id: "dark-v10", label: "Dark" },
];

const DEFAULT_BASEMAP_ID = CLASSIC_BASEMAPS[0].id;

export function basemapTileUrl(styleId) {
  const id = CLASSIC_BASEMAPS.some((b) => b.id === styleId)
    ? styleId
    : DEFAULT_BASEMAP_ID;
  return `https://api.mapbox.com/styles/v1/mapbox/${id}/tiles/256/{z}/{x}/{y}@2x?access_token=${getConfig().mapboxToken}`;
}

export const useBasemapStore = create(
  persist(
    (set) => ({
      activeBasemapId: DEFAULT_BASEMAP_ID,
      setBasemap: (id) => set({ activeBasemapId: id }),
    }),
    {
      name: PERSIST_KEYS.basemap,
    }
  )
);
